<template>
  <div id="TimeSelect" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">T</span>iempo</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 lh46 pb10 bg-color-white color-muted" style="overflow-y: auto;">
      <div class="col-12 uppercase f14">
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(6)"> 
          <div class="col-10" :class="$store.state.app_args.report_date == 6 ? 'color-black' : ''">El mes pasado</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 6 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(5)">
          <div class="col-10" :class="$store.state.app_args.report_date == 5 ? 'color-black' : ''">La semana pasada</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 5 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(4)"> 
          <div class="col-10" :class="$store.state.app_args.report_date == 4 ? 'color-black' : ''">Este mes</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 4 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(3)"> 
          <div class="col-10" :class="$store.state.app_args.report_date == 3 ? 'color-black' : ''">Esta semana</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 3 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(2)"> 
          <div class="col-10" :class="$store.state.app_args.report_date == 2 ? 'color-black' : ''">Ayer</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 2 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(1)"> 
          <div class="col-10" :class="$store.state.app_args.report_date == 1 ? 'color-black' : ''">Hoy</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 1 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(7)">
          <div class="col-10" :class="$store.state.app_args.report_date == 7 ? 'color-black' : ''">últimos 7 días</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 7 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 bb1 pl10 pr10" @click="timeCh(8)">
          <div class="col-10" :class="$store.state.app_args.report_date == 8 ? 'color-black' : ''">últimos 30 días</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 8 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
        <div class="col-12 pl10 pr10" @click="timeCh(9)">
          <div class="col-10" :class="$store.state.app_args.report_date == 9 ? 'color-black' : ''">últimos 90 días</div>
          <div class="col-2 t-r"><i class="iconfont f18" :class="$store.state.app_args.report_date == 9 ? 'icon-Raidobox-xuanzhong color-primary' : 'icon-Raidobox-weixuan color-muted'"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TimeSelect',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
  },
  methods: {
    timeCh(i){
      this.$store.commit('setAppArgs',{report_date:i});
      this.$router.back(-1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/TimeSelect.vue